import * as roomActions from '../actions/rooms.action';
import { Room } from '../../booking/models/room';

export interface State {
  availableRooms: Room[];
  selectedRoom: Room;
}

export const initialState: State = {
  availableRooms: [
    {
      id: 'standard-room-single',
      maxAvailable: 50,
      quantityAvailable: 50,
      name: 'Standard (Single)',
      price: 212,
      imageUrls: [
        // tslint:disable-next-line:max-line-length
        'https://firebasestorage.googleapis.com/v0/b/emp21charlitex.appspot.com/o/new-std-single-1.JPG?alt=media&token=fc9f5b28-8dc8-47b9-a7a7-85bbc64d9ed4'
      ],
      amenities: [
        {
          name: 'Air Condition',
          icon: 'hotelicon hotelicon-air-condition'
        },
        {
          name: 'Shower',
          icon: 'hotelicon hotelicon-bathtub'
        },
        {
          name: 'TV',
          icon: 'hotelicon hotelicon-tv'
        },
        {
          name: 'Working area',
          icon: 'hotelicon hotelicon-coctail'
        },
        {
          name: '150MB WIFI',
          icon: 'hotelicon hotelicon-wifi'
        },
        {
          name: 'Coffee Area',
          icon: 'hotelicon hotelicon-coffee'
        },
        {
          name: 'Bed',
          icon: 'hotelicon hotelicon-bed'
        }
      ]
    },
    {
      id: 'standard-room-sharing',
      maxAvailable: 50,
      quantityAvailable: 50,
      name: 'Standard (Sharing)',
      price: 175,
      imageUrls: [
        // tslint:disable-next-line:max-line-length
        'https://firebasestorage.googleapis.com/v0/b/emp21charlitex.appspot.com/o/new-std-double-1.JPG?alt=media&token=cabcb838-9b15-4aab-9c64-e25fa7b92d69',
        'https://firebasestorage.googleapis.com/v0/b/emp21charlitex.appspot.com/o/std-double-2.jpeg?alt=media&token=7d7ce93c-6f77-44c8-8d9c-8f03c4b5164b'
      ],
      amenities: [
        {
          name: 'Air Condition',
          icon: 'hotelicon hotelicon-air-condition'
        },
        {
          name: 'Shower',
          icon: 'hotelicon hotelicon-bathtub'
        },
        {
          name: 'TV',
          icon: 'hotelicon hotelicon-tv'
        },
        {
          name: 'Working area',
          icon: 'hotelicon hotelicon-coctail'
        },
        {
          name: '150MB WIFI',
          icon: 'hotelicon hotelicon-wifi'
        },
        {
          name: 'Coffee Area',
          icon: 'hotelicon hotelicon-coffee'
        },
        {
          name: 'Bed',
          icon: 'hotelicon hotelicon-bed'
        }
      ]
    },
    {
      id: 'deluxe-room-single',
      maxAvailable: 50,
      quantityAvailable: 50,
      name: 'Deluxe (Single)',
      price: 300,
      imageUrls: [
        // tslint:disable-next-line:max-line-length
        'https://firebasestorage.googleapis.com/v0/b/emp21charlitex.appspot.com/o/new-deluxe-single-1.jpg?alt=media&token=45fc3343-79f3-4094-8e80-ed9eebf697e7',
        'https://firebasestorage.googleapis.com/v0/b/emp21charlitex.appspot.com/o/new-deluxe-single-2.jpg?alt=media&token=baeda410-4f7c-4045-97d7-29abd18321b0'
      ],
      amenities: [
        {
          name: 'Air Condition',
          icon: 'hotelicon hotelicon-air-condition'
        },
        {
          name: 'Shower',
          icon: 'hotelicon hotelicon-bathtub'
        },
        {
          name: 'TV',
          icon: 'hotelicon hotelicon-tv'
        },
        {
          name: 'Working area',
          icon: 'hotelicon hotelicon-coctail'
        },
        {
          name: '150MB WIFI',
          icon: 'hotelicon hotelicon-wifi'
        },
        {
          name: 'Coffee Area',
          icon: 'hotelicon hotelicon-coffee'
        },
        {
          name: 'Bed',
          icon: 'hotelicon hotelicon-bed'
        },
        {
          name: 'Bedside Phone',
          icon: 'hotelicon hotelicon-phone'
        }
      ]
    },
    {
      id: 'deluxe-room-sharing',
      maxAvailable: 50,
      quantityAvailable: 50,
      name: 'Deluxe (Sharing)',
      price: 200,
      imageUrls: [
        // tslint:disable-next-line:max-line-length
        'https://firebasestorage.googleapis.com/v0/b/emp21charlitex.appspot.com/o/new-deluxe-sharing-1.jpg?alt=media&token=54ec6c94-efcd-4ae4-8273-a222307741c6'
      ],
      amenities: [
        {
          name: 'Air Condition',
          icon: 'hotelicon hotelicon-air-condition'
        },
        {
          name: 'Shower',
          icon: 'hotelicon hotelicon-bathtub'
        },
        {
          name: 'TV',
          icon: 'hotelicon hotelicon-tv'
        },
        {
          name: 'Working area',
          icon: 'hotelicon hotelicon-coctail'
        },
        {
          name: '150MB WIFI',
          icon: 'hotelicon hotelicon-wifi'
        },
        {
          name: 'Coffee Area',
          icon: 'hotelicon hotelicon-coffee'
        },
        {
          name: 'Bed',
          icon: 'hotelicon hotelicon-bed'
        },
        {
          name: 'Bedside Phone',
          icon: 'hotelicon hotelicon-phone'
        }
      ]
    },
    {
      id: 'executive-room-single',
      maxAvailable: 50,
      quantityAvailable: 50,
      name: 'Executive (Single)',
      price: 350,
      imageUrls: [
        // tslint:disable-next-line:max-line-length
        'https://firebasestorage.googleapis.com/v0/b/emp21charlitex.appspot.com/o/exec-single-2.JPG?alt=media&token=7fb85a9f-5d18-4338-bfae-f754ef329287',
        'https://firebasestorage.googleapis.com/v0/b/emp21charlitex.appspot.com/o/new-exec-single-2.jpg?alt=media&token=8f335d9a-4d14-435e-9b94-79eaa0b9c7eb',
        'https://firebasestorage.googleapis.com/v0/b/emp21charlitex.appspot.com/o/new-exec-single-1.jpg?alt=media&token=2aaa5857-c197-4740-ac03-3b0c31b806b7',
        'https://firebasestorage.googleapis.com/v0/b/emp21charlitex.appspot.com/o/exec-single-2.JPG?alt=media&token=7fb85a9f-5d18-4338-bfae-f754ef329287',
        'https://firebasestorage.googleapis.com/v0/b/emp21charlitex.appspot.com/o/exec-single-3.JPG?alt=media&token=7f3c14e6-799a-4612-9a96-5b18de6b528f',
        // tslint:disable-next-line:max-line-length
        'https://firebasestorage.googleapis.com/v0/b/emp21charlitex.appspot.com/o/exec-single.JPG?alt=media&token=c8bba328-7d2c-40a0-b0c0-983b10b04ba1'
      ],
      amenities: [
        {
          name: 'Air Condition',
          icon: 'hotelicon hotelicon-air-condition'
        },
        {
          name: 'Shower',
          icon: 'hotelicon hotelicon-bathtub'
        },
        {
          name: 'TV with DSTV',
          icon: 'hotelicon hotelicon-tv'
        },
        {
          name: 'Kitchen Appliance',
          icon: 'hotelicon hotelicon-kitchen'
        },
        {
          name: 'Working area',
          icon: 'hotelicon hotelicon-coctail'
        },
        {
          name: '150MB WIFI',
          icon: 'hotelicon hotelicon-wifi'
        },
        {
          name: 'Coffee Machine',
          icon: 'hotelicon hotelicon-coffee'
        },
        {
          name: 'Bed',
          icon: 'hotelicon hotelicon-king-bed'
        },
        {
          name: 'Bedside Phone',
          icon: 'hotelicon hotelicon-phone'
        },
        {
          name: 'Mini bar',
          icon: 'hotelicon hotelicon-dining'
        }
      ]
    },
    {
      id: 'executive-room-sharing',
      maxAvailable: 50,
      quantityAvailable: 50,
      name: 'Executive (Sharing)',
      price: 225,
      imageUrls: [
        // tslint:disable-next-line:max-line-length
        'https://firebasestorage.googleapis.com/v0/b/emp21charlitex.appspot.com/o/exec-sharing-1.JPG?alt=media&token=c11a149b-06cb-4ea4-82ae-f6b3033a3a15',
        'https://firebasestorage.googleapis.com/v0/b/emp21charlitex.appspot.com/o/exec-sharing-2.JPG?alt=media&token=1498d4d8-a45c-42cf-9343-d863fd2fe0e2'
      ],
      amenities: [
        {
          name: 'Air Condition',
          icon: 'hotelicon hotelicon-air-condition'
        },
        {
          name: 'Shower',
          icon: 'hotelicon hotelicon-bathtub'
        },
        {
          name: 'TV with DSTV',
          icon: 'hotelicon hotelicon-tv'
        },
        {
          name: 'Kitchen Appliance',
          icon: 'hotelicon hotelicon-kitchen'
        },
        {
          name: 'Working area',
          icon: 'hotelicon hotelicon-coctail'
        },
        {
          name: '150MB WIFI',
          icon: 'hotelicon hotelicon-wifi'
        },
        {
          name: 'Coffee Machine',
          icon: 'hotelicon hotelicon-coffee'
        },
        {
          name: 'Bed',
          icon: 'hotelicon hotelicon-king-bed'
        },
        {
          name: 'Bedside Phone',
          icon: 'hotelicon hotelicon-phone'
        },
        {
          name: 'Mini bar',
          icon: 'hotelicon hotelicon-dining'
        }
      ]
    },
    {
      id: 'luxury-room-single',
      maxAvailable: 50,
      quantityAvailable: 50,
      name: 'Luxury (Single)',
      price: 350,
      imageUrls: [
        'https://firebasestorage.googleapis.com/v0/b/emp21charlitex.appspot.com/o/new-lux-single-1.jpg?alt=media&token=1635db3f-af90-423d-9515-ff7fd029befd',
        'https://firebasestorage.googleapis.com/v0/b/emp21charlitex.appspot.com/o/new-lux-single-2.jpg?alt=media&token=efb327c1-5b45-49d7-9ba4-8666819f2c59',
        'https://firebasestorage.googleapis.com/v0/b/emp21charlitex.appspot.com/o/new-lux-single-3.jpg?alt=media&token=4902c156-8db6-43d4-96ec-73c86cd069ee'
      ],
      amenities: [
        {
          name: 'Air Condition',
          icon: 'hotelicon hotelicon-air-condition'
        },
        {
          name: 'Shower',
          icon: 'hotelicon hotelicon-bathtub'
        },
        {
          name: 'TV with DSTV',
          icon: 'hotelicon hotelicon-tv'
        },
        {
          name: 'Kitchen Appliance',
          icon: 'hotelicon hotelicon-kitchen'
        },
        {
          name: 'Working area',
          icon: 'hotelicon hotelicon-coctail'
        },
        {
          name: '150MB WIFI',
          icon: 'hotelicon hotelicon-wifi'
        },
        {
          name: 'Coffee Machine',
          icon: 'hotelicon hotelicon-coffee'
        },
        {
          name: 'Bed',
          icon: 'hotelicon hotelicon-king-bed'
        },
        {
          name: 'Bedside Phone',
          icon: 'hotelicon hotelicon-phone'
        },
        {
          name: 'Mini bar',
          icon: 'hotelicon hotelicon-dining'
        }
      ]
    },
    {
      id: 'luxury-room-sharing',
      maxAvailable: 50,
      quantityAvailable: 50,
      name: 'Luxury (Sharing)',
      price: 225,
      imageUrls: [
        'https://firebasestorage.googleapis.com/v0/b/emp21charlitex.appspot.com/o/lux-double-1.jpeg?alt=media&token=f72fe303-147d-464e-aa32-e272c3466425'
      ],
      amenities: [
        {
          name: 'Air Condition',
          icon: 'hotelicon hotelicon-air-condition'
        },
        {
          name: 'Shower',
          icon: 'hotelicon hotelicon-bathtub'
        },
        {
          name: 'TV with DSTV',
          icon: 'hotelicon hotelicon-tv'
        },
        {
          name: 'Kitchen Appliance',
          icon: 'hotelicon hotelicon-kitchen'
        },
        {
          name: 'Working area',
          icon: 'hotelicon hotelicon-coctail'
        },
        {
          name: '150MB WIFI',
          icon: 'hotelicon hotelicon-wifi'
        },
        {
          name: 'Coffee Machine',
          icon: 'hotelicon hotelicon-coffee'
        },
        {
          name: 'Bed',
          icon: 'hotelicon hotelicon-king-bed'
        },
        {
          name: 'Bedside Phone',
          icon: 'hotelicon hotelicon-phone'
        },
        {
          name: 'Mini bar',
          icon: 'hotelicon hotelicon-dining'
        }
      ]
    }
  ],
  selectedRoom: null
};

export function reducer(
  state: State = initialState,
  action: roomActions.roomActions
) {
  switch (action.type) {
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/store/reducers/rooms.reducer.ts